import { inject } from "@angular/core";
import { CanActivateFn, Router } from "@angular/router";
import { Store } from "@ngxs/store";
import { AuthSessionFacade } from "@services/auth-session/auth-session.facade";
import { RESTORE_AUTH_SESSION } from "@store/user/user.action";
import { UserState } from "@store/user/user.state";
import { catchError, map, of } from "rxjs";

export const authGuard: CanActivateFn = (_route) => {
  const store = inject(Store);
  const router = inject(Router);
  const authSessionFacade = inject(AuthSessionFacade);

  const isLoggedIn = store.selectSnapshot(UserState.isLoggedIn);

  if (isLoggedIn) {
    return true;
  }

  if (authSessionFacade.hasSession()) {
    return store.dispatch(new RESTORE_AUTH_SESSION({})).pipe(
      map(() =>
        store.selectSnapshot(UserState.isLoggedIn)
          ? true
          : router.createUrlTree(["/login"]),
      ),
      catchError(() => of(router.createUrlTree(["/login"]))),
    );
  }

  return router.createUrlTree(["/login"]);
};
